/**
 * Dialog - Modal dialog component with iframe support
 * Handles opening, closing, and stopping iframe media playback
 */
class Dialog {
  constructor(dialog, dialogOpener, dialogCloser) {
    this.dialog = dialog;
    this.dialogOpener = dialogOpener;

    this.iframe = dialog.querySelector('iframe');

    dialogOpener.addEventListener('click', this.openModal.bind(this));
    dialogCloser.addEventListener('click', this.closeModal.bind(this));
  }

  openModal() {
    this.dialog.showModal();
  }

  closeModal() {
    if (this.iframe) {
      // Stop any media playing from the iframe when the modal is closed.
      const iframeSrc = this.iframe.getAttribute('src');
      this.iframe.removeAttribute('src');
      setTimeout(() => {
        this.iframe.setAttribute('src', iframeSrc);
      }, 500);
    }

    // Close the dialog
    this.dialog.close();
  }
}

export default Dialog;
